import { render, staticRenderFns } from "./VAlert.vue?vue&type=template&id=aa3ae76e&"
import script from "./VAlert.vue?vue&type=script&lang=js&"
export * from "./VAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports